import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  useMediaQuery,
  useTheme,
} from '@mui/material'

import { useGetUserReferrals } from 'src/hooks'

import { Loader } from 'src/components/loader'
import { HelperWrapper } from 'src/components/helper-wrapper'

import { useStyles } from './../styles'
import { ReferralsTableItem } from './referrals-table-item.component'
import { sortToObject } from 'src/common/utils'
import { useState } from 'react'

interface IProps {
  timezone?: string
}

const ReferralsTable = ({ timezone }: IProps) => {
  const theme = useTheme()
  const classes = useStyles()

  const [sort, setSort] = useState('created_at-desc')

  const isTablet = useMediaQuery(theme.breakpoints.down('tablet'))

  const { data: referrals, isLoading } = useGetUserReferrals({
    ...sortToObject(sort),
  })

  if (isLoading || !referrals) {
    return (
      <Box sx={{ width: '100%', textAlign: 'center', mt: '50px' }}>
        <Loader isStatic />
      </Box>
    )
  }

  if (referrals.length < 1) {
    return null
  }

  const sortActive = sort.split('-')[0]
  const sortDirection = sort.split('-')[1] as 'desc' | 'asc'

  const handleSortChange = (sortName: string) => () => {
    setSort((prevSort) =>
      prevSort.split('-')[1] === 'asc' ? `${sortName}-desc` : `${sortName}-asc`,
    )
  }

  return (
    <TableContainer sx={{ overflowX: 'auto', mb: '50px', maxWidth: '1440px' }}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell sx={{ px: isTablet ? '4px' : '16px', fontSize: isTablet ? '10px' : '14px' }}>
              <TableSortLabel
                onClick={handleSortChange('user')}
                active={sortActive === 'user'}
                direction={sortDirection}
              >
                <HelperWrapper t="invite-friends-user-column" />
              </TableSortLabel>
            </TableCell>
            {/* <TableCell sx={{ px: isTablet ? '4px' : '16px', fontSize: isTablet ? '10px' : '14px' }}>
              <TableSortLabel
                onClick={handleSortChange('wallet')}
                active={sortActive === 'wallet'}
                direction={sortDirection}
              >
                Wallet
              </TableSortLabel>
            </TableCell> */}
            <TableCell
              align="center"
              sx={{ px: isTablet ? '4px' : '16px', fontSize: isTablet ? '10px' : '14px' }}
            >
              <TableSortLabel
                onClick={handleSortChange('scans')}
                active={sortActive === 'scans'}
                direction={sortDirection}
                sx={{
                  marginLeft: '20px',
                }}
              >
                <HelperWrapper t="invite-friends-scans-column" />
              </TableSortLabel>
            </TableCell>
            <TableCell
              align="center"
              sx={{
                px: isTablet ? '4px' : '16px',
                fontSize: isTablet ? '10px' : '14px',
              }}
            >
              <TableSortLabel
                onClick={handleSortChange('created_at')}
                active={sortActive === 'created_at'}
                direction={sortDirection}
                sx={{
                  marginLeft: '20px',
                }}
              >
                <HelperWrapper t="invite-friends-sign-up-date-column" />
              </TableSortLabel>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {referrals.map((item) => (
            <ReferralsTableItem key={item.id} item={item} timezone={timezone} />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export { ReferralsTable }
